var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnMusicOn = function SvgBtnMusicOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 31c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15Zm0 1c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z",
    fill: "#753BBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.707 15.626v4.823h-.004v.001a2.352 2.352 0 1 1-1.497-2.192v-5.466c0-.854.56-1.608 1.378-1.853L19.11 9.28a1.935 1.935 0 0 1 2.49 1.853v8.314a2.352 2.352 0 1 1-1.501-2.26v-3.48l-6.392 1.918Zm0-1.567v-1.267c0-.192.125-.36.309-.415l5.525-1.658a.434.434 0 0 1 .558.415v1.007l-6.392 1.918Zm6.392 5.186a.861.861 0 1 0 .008.203h-.008v-.203Zm-7.893 1.204v-.108a.861.861 0 1 0 .007.109v-.001h-.007Z",
    fill: "#753BBD"
  })));
};
export default SvgBtnMusicOn;